import { useSelector } from 'react-redux';

import { modalDetailsSelector } from '../store/redux-slices/modals/selectors';

export function useModalDetails<T = any>(name: string) {
  const details: T = useSelector(modalDetailsSelector(name));

  return details;
}
